import React from "react";

const stars = [
  { top: "7%", left: "8%", size: 2.5, delay: "0s", duration: "3.6s" },
  { top: "11%", left: "22%", size: 2, delay: "0.9s", duration: "4.2s" },
  { top: "16%", left: "64%", size: 2.6, delay: "1.1s", duration: "4.8s" },
  { top: "21%", left: "88%", size: 2.2, delay: "1.8s", duration: "4.3s" },
  { top: "28%", left: "14%", size: 3, delay: "0.4s", duration: "4.9s" },
  { top: "34%", left: "38%", size: 2.1, delay: "2.2s", duration: "3.9s" },
  { top: "41%", left: "79%", size: 2.8, delay: "1.5s", duration: "4.6s" },
  { top: "49%", left: "10%", size: 2.3, delay: "2.8s", duration: "4.7s" },
  { top: "58%", left: "61%", size: 2.8, delay: "0.6s", duration: "4.2s" },
  { top: "67%", left: "88%", size: 2, delay: "1.9s", duration: "5.1s" },
  { top: "74%", left: "29%", size: 2.6, delay: "0.2s", duration: "4.3s" },
  { top: "81%", left: "71%", size: 3, delay: "2.5s", duration: "4.9s" },
  { top: "92%", left: "17%", size: 2.2, delay: "1.3s", duration: "3.8s" },
];

const streaks = [
  { top: "18%", left: "76%", delay: "0.4s", duration: "9s" },
  { top: "43%", left: "86%", delay: "3.1s", duration: "10s" },
  { top: "71%", left: "68%", delay: "1.4s", duration: "11s" },
];

export default function MatrixBackground({ children, className = "" }) {
  return (
    <div
      className={`relative overflow-hidden bg-[radial-gradient(circle_at_top,rgba(38,170,255,0.18),transparent_22%),radial-gradient(circle_at_18%_16%,rgba(38,170,255,0.11),transparent_24%),radial-gradient(circle_at_82%_10%,rgba(0,180,255,0.10),transparent_18%),linear-gradient(180deg,#030b17_0%,#07162d_36%,#051326_65%,#020913_100%)] text-white ${className}`}
    >
      <style>{`
        @keyframes matrixTwinkle {
          0%,100% { opacity: .25; transform: scale(.92); }
          50% { opacity: .95; transform: scale(1.35); }
        }
        @keyframes matrixDrift {
          0% { transform: translate3d(0,0,0); }
          50% { transform: translate3d(-1.5%, 1%, 0); }
          100% { transform: translate3d(-3%, 2%, 0); }
        }
        @keyframes dataSweep {
          0% { transform: translate3d(0,0,0) rotate(17deg); opacity: 0; }
          12% { opacity: .8; }
          60% { opacity: .12; }
          100% { transform: translate3d(-440px,240px,0) rotate(17deg); opacity: 0; }
        }
        .matrix-grid::before,
        .matrix-grid::after {
          content: "";
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(59,130,246,.08) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59,130,246,.08) 1px, transparent 1px);
          background-size: 72px 72px;
          mask-image: radial-gradient(circle at 50% 12%, rgba(0,0,0,.88), transparent 78%);
          opacity: .42;
          pointer-events: none;
        }
        .matrix-grid::after {
          transform: perspective(1200px) rotateX(74deg) scale(1.18);
          transform-origin: top center;
          opacity: .22;
        }
        .matrix-orb {
          filter: blur(48px);
          opacity: .55;
          pointer-events: none;
        }
      `}</style>

      <div className="matrix-grid absolute inset-0" />
      <div className="matrix-orb absolute -top-16 left-[12%] h-40 w-40 rounded-full bg-cyan-400/20" />
      <div className="matrix-orb absolute top-24 right-[10%] h-48 w-48 rounded-full bg-blue-500/15" />
      <div className="matrix-orb absolute bottom-20 left-[26%] h-56 w-56 rounded-full bg-sky-500/10" />

      <div className="absolute inset-0 pointer-events-none">
        {stars.map((star, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white shadow-[0_0_22px_rgba(255,255,255,.95)]"
            style={{
              top: star.top,
              left: star.left,
              width: `${star.size}px`,
              height: `${star.size}px`,
              animation: `matrixTwinkle ${star.duration} ease-in-out ${star.delay} infinite`,
            }}
          />
        ))}
        {streaks.map((streak, i) => (
          <span
            key={`streak-${i}`}
            className="absolute h-[2px] w-40 rounded-full bg-[linear-gradient(90deg,rgba(255,255,255,0),rgba(146,232,255,.9),rgba(0,153,255,.35),rgba(0,153,255,0))] opacity-0"
            style={{
              top: streak.top,
              left: streak.left,
              boxShadow: "0 0 26px rgba(34,211,238,.7)",
              animation: `dataSweep ${streak.duration} linear ${streak.delay} infinite`,
            }}
          />
        ))}
      </div>

      {children}
    </div>
  );
}
